import {lcFirst, splitOnCapitals} from "utils/stringFunctions"

export function objectStringToId(str: string) {
  return str.replace('.', '-')
}

export function strToId(str: string) {
  return str.split(' ').map(s => lcFirst(s).split('/').map(s => lcFirst(s)).join('-')).join('-')
}

export function widgetPathToId(str: string) {
  const withoutFile = strToId(str).split('-')
  withoutFile.pop()
  return withoutFile.join('-')
}

export function strToCss(str: string) {
  return splitOnCapitals(str).map(s => lcFirst(s)).join('-').split(' ').map(s => lcFirst(s)).join('-')
}
